export default __webpack_public_path__ + "static/media/ytvideo.1c2ef1e2.svg";